var __templateData = Handlebars.template({"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
  var helper, functionType="function", helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;
  return "<td><span class=\"caption\">"
    + escapeExpression(((helper = (helper = helpers.givenNames || (depth0 != null ? depth0.givenNames : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"givenNames","hash":{},"data":data}) : helper)))
    + " "
    + escapeExpression(((helper = (helper = helpers.lastName || (depth0 != null ? depth0.lastName : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"lastName","hash":{},"data":data}) : helper)))
    + "</span></td>\n<td><span class=\"caption\">"
    + escapeExpression(((helper = (helper = helpers.approvalComments || (depth0 != null ? depth0.approvalComments : depth0)) != null ? helper : helperMissing),(typeof helper === functionType ? helper.call(depth0, {"name":"approvalComments","hash":{},"data":data}) : helper)))
    + "</span></td>\n";
},"useData":true});
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}